import PropTypes from "prop-types";
import React, { Component } from "react";
import style from "./style/textincircle.scss";

class TextInCircle extends Component {
    render() {
        const { action, classes, children, cyReference } = this.props;

        return (
            <div
                className={`${style.textincircle_container} ${classes.root}`}
                data-cy={cyReference || ""}
                role="button"
                tabIndex="-1"
                onClick={action}
            >
                <span>{children}</span>
            </div>
        );
    }
}

export default TextInCircle;

TextInCircle.propTypes = {
    action: PropTypes.func,
    children: PropTypes.any,
    classes: PropTypes.object,
};

TextInCircle.defaultProps = {
    classes: {
        root: {},
    },
};
